
(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .service('Menu', MenuService);

  MenuService.$inject = ['Auth', '$resource'];

  function MenuService (Auth, $resource) {
    const menuResource = $resource('/api/app/menu');
    let menuTexts;

    function getMenu () {
      const language = Auth.getCurrentUserLanguage();

      if (menuTexts) {
        return Promise.resolve(menuTexts);
      }

      return menuResource.get().$promise.then(function (res) {
        menuTexts = res.toJSON();

        for (const key in menuTexts) {
          if (menuTexts.hasOwnProperty(key) && angular.isArray(menuTexts[key])) {
            menuTexts[key].forEach((menuItem) => {
              if (menuItem.languages[language] && menuItem.languages[language].title) {
                menuItem.title = menuItem.languages[language].title;
              }
              if (menuItem.languages[language] && menuItem.languages[language].addButton) {
                menuItem.addButton.title = menuItem.languages[language].addButton;
              }
            });
          }
        }

        return Promise.resolve(menuTexts);
      });
    }

    function getAll () {
      return menuTexts;
    }

    return {
      getMenu: getMenu,
      getAll: getAll,
    };
  }

})();
